export default __webpack_public_path__ + "static/media/844.8a085b4c.png";